import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M258 908H742V244H258ZM330 92V20H670V92ZM366 364H437V788H366ZM563 364H634V788H563ZM70 244V172H930V244H820V894C820 948 788 980 734 980H266C210 980 180 948 180 894V244Z" })
});
export default SvgDelete;
